module.exports = __webpack_public_path__ + "static/sunny-e72b522c95659ae9a64a3a655f56268d.jpg";